export enum ClientStatus {
  CurrentClient = 1,
  Prospect = 2,
  Dormant = 3,
  Onboarding = 4
}

// Prospect-stage clients live on the Prospects tab; everything else (including
// no-status and unknown statuses) belongs to Home.
export const isProspectStage = (clientStatusID?: number | null): boolean =>
  clientStatusID === ClientStatus.Prospect ||
  clientStatusID === ClientStatus.Onboarding;
